import { render } from "./EditGiftPage.vue?vue&type=template&id=715644db&bindings={\"giftId\":\"props\",\"eventId\":\"props\"}"
import script from "./EditGiftPage.vue?vue&type=script&lang=js"
export * from "./EditGiftPage.vue?vue&type=script&lang=js"
script.render = render

export default script